import React from 'react';
import { UserProvider } from '../auth/UseUser';

const AppProviders = ({ children }: any) => {
	return <UserProvider>{children}</UserProvider>;
};

export default AppProviders;
